import { FilterKey } from "@/models/FilterKey";
import Filter from "../../Filter.class";
import { IFilterProvider } from "@/interfaces/filter-providers/IFilterProvider";

export default class CertificationTypeFilter extends Filter {
	constructor(filterProvider: IFilterProvider) {
		super(FilterKey.DEGREE_TYPE, filterProvider);
	}
}
